module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/tackle-twill-e44dbcfe9432e74358e62f4f5fe33c37.jpg";